import { Navigate, Route, Routes } from 'react-router-dom';

import { useState } from 'react';

import { useAuth } from './lib/auth-context.js';
import { LocaleSync } from './lib/locale-sync.js';
import { AppLayout } from './routes/AppLayout.js';
import { CustomersPage } from './routes/CustomersPage.js';
import { LoginPage } from './routes/LoginPage.js';
import { OrdersPage } from './routes/OrdersPage.js';
import { ProductsPage } from './routes/ProductsPage.js';
import { SettingsPage } from './routes/SettingsPage.js';
import { SignupPage } from './routes/SignupPage.js';

export const App = (): React.JSX.Element => {
  const { user, isLoading } = useAuth();
  // Signup is the default for a signed-out visitor: someone arriving without a
  // store is far more likely to be creating one than returning to it.
  const [showSignup, setShowSignup] = useState(true);

  // Hold the render until the refresh-cookie restore settles, otherwise a
  // signed-in user sees the login screen flash on every reload.
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!user) {
    return showSignup ? (
      <SignupPage
        onSignIn={() => {
          setShowSignup(false);
        }}
      />
    ) : (
      <LoginPage
        onCreateStore={() => {
          setShowSignup(true);
        }}
      />
    );
  }

  return (
    <>
      <LocaleSync />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Route>
      </Routes>
    </>
  );
};
